(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/draws/assets/javascripts/services/fetch-single-draw.js') >= 0) return;  svs.modules.push('/components/marketplace-data/draws/assets/javascripts/services/fetch-single-draw.js');
"use strict";


const cachedJupiterGet = svs.components.marketplaceData.cachedJupiterGet;
const helpers = svs.components.marketplaceData.draws.helpers;
const getSpecificDrawName = svs.utils.products.getSpecificDrawName;
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const fetchSingleDraw = async (productId, drawNumber, callback) => {
  const wrappedLegacyTransport = url => new Promise((resolve, reject) => {
    fetchSingleDraw.cacheRequest(url, data => resolve({
      ok: true,
      json: async () => data
    }), error => reject(error.responseJSON.error));
  });
  const specificDrawname = getSpecificDrawName(productId);
  const url = "/draw/1/".concat(specificDrawname, "/draws/").concat(drawNumber, "?include=").concat(encodeURIComponent(specificDrawname === 'bomben' ? helpers.bombenDrawInclude('draw') : helpers.drawInclude('draw')));
  try {
    const proxy = ApiProxy.create([], {
      legacyTransport: wrappedLegacyTransport
    });
    const result = await proxy.fetch(url);
    callback(undefined, {
      draws: [helpers.normalizeDraw(result.draw)]
    });
  } catch (error) {
    callback(error);
  }
};
fetchSingleDraw.cacheRequest = cachedJupiterGet.createCache(3000);
setGlobal('svs.components.marketplaceData.draws.services.fetchSingleDraw', fetchSingleDraw);

 })(window);